import React, { FC, ReactNode, useState } from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';
import Theme from '@adsk/alloy-react-theme';

interface TrialModalItemProps {
  children: ReactNode[];
}

const TrialModalCarousel: FC<TrialModalItemProps> = ({ children }) => {
  const [active, setActive] = useState(0);
  return (
    <Flex
      alignItems="center"
      border={`1px solid ${Theme.colors.charcoal200}`}
      borderRadius="4px"
      flexDirection="column"
      width="100%"
    >
      {children[active]}
      <Flex justifyContent="space-evenly" width={`${children.length * 3}%`}>
        {children.map((_, index) => {
          return (
            <Box
              backgroundColor={
                active === index
                  ? Theme.colors.charcoal600
                  : Theme.colors.charcoal200
              }
              borderRadius="50%"
              display="inline"
              height="8px"
              left="50%"
              margin="-4px 0"
              position="relative"
              top="-15px"
              width="8px"
              style={{
                cursor: 'pointer',
              }}
              data-testid={`TrialModalCarouselDot${index}`}
              key={`carousel-dot-${index}`}
              onClick={() => {
                setActive(index);
              }}
            />
          );
        })}
      </Flex>
    </Flex>
  );
};

TrialModalCarousel.displayName = 'TrialModalCarousel';

export default TrialModalCarousel;
